import { getPerformance, trace } from "firebase/performance";
import { getApps } from "firebase/app";
import { createPersistedState } from "~/utils/persistedState";


 interface userProfilData {
  userChoice: userMarketPlace;
  // formToSend: FormData;
  imgDisplay: {
    coverPicture:string,
    profilePicture: string
  };
  MarketPlace : existMarketPlace;
  isChanged : boolean;
  screenWidth : number;
}

const state = (): userProfilData => ({
  userChoice: {} as userMarketPlace,
  // formToSend: new FormData(),
  MarketPlace : {} as existMarketPlace,
  imgDisplay: {
    coverPicture: "",
    profilePicture: ''
  },
  isChanged : false,
  screenWidth : 1200,
});

const getters = {
  getUserProfil: (state: userProfilData) => {
    return state.userChoice;
  },
  getImgDisplay: (state: userProfilData) => {
    return state.imgDisplay;
  },
  getMarketPlaceDetails: (state: userProfilData) => {
    return state.MarketPlace.details;
  },
  getMarketPlaceWorkDays: (state: userProfilData) => {
    return state.MarketPlace.workDays;
  },
};

export const useMarketPlace = defineStore("useMarketPlace",  {
  state,
  getters,
  actions: {

    setChanged(value: boolean) {
      this.isChanged = value;
    },

    setScreenWidth(value: any) {
      this.screenWidth = value;
    },
    
    async imgDisplayCollect(values: any , key : string) {
      if (key === 'cover') {
        this.imgDisplay.coverPicture = values;
      }
      if (key === 'logo') {
        this.imgDisplay.profilePicture = values;
      }
    },
    async collectUserInput(values: userMarketPlace) {
      this.userChoice = values;
    },
    async creatNewMarket(formdata: FormData, hours: WorkHours , id : number) {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      let fetchTrace;
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'creatNewMarket');
        fetchTrace.start();
      }

      try {
         await $fetch<any>("/marketplaces/new", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + cookie.value,
          },
          body: formdata,

          baseURL: runTimeConfig.public.baseUrl,
        })
        await $fetch<any>("/marketplaces/set-workdays", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + cookie.value,
          },
          body: {
            marketplaceId: id,
            days: hours.days,
          },

          baseURL: runTimeConfig.public.baseUrl,
        })
      } catch (error) {
        // console.log(error);
        throw new Error(String(error))
      } finally {
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }
    },
    async editMarketAndWorkdays(formdata: FormData, hours: WorkHours , id : number) {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      const { error: marketError, data: marketData, execute: executeMarket } = useFetch(
          () => `${runTimeConfig.public.baseUrl}/marketplaces/edit`,
          {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${cookie.value}`,
            },
            body: formdata,
            immediate: false, // important: don't run immediately
          }
        );
        const { error: workdaysError, data: workdaysData, execute: executeWorkdays } = useFetch(
            () => `${runTimeConfig.public.baseUrl}/marketplaces/edit-workdays`,
            {
              method: "PUT",
              headers: {
                Authorization: `Bearer ${cookie.value}`,
              },
              body: {
                marketplaceId: id,
                days: hours.days,
              },
              immediate: false,
            }
        );
      try {
          /*$fetch<any>("/marketplaces/edit", {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + cookie.value,
          },
          body: formdata,

          baseURL: runTimeConfig.public.baseUrl,
        })
          
         $fetch<any>("/marketplaces/edit-workdays", {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + cookie.value,
          },
          body: {
            marketplaceId: id,
            days: hours.days,
          },
          baseURL: runTimeConfig.public.baseUrl,
        })
        */
      
       await executeMarket();
        if (marketError.value) {
          const msg =
            marketError.value?.data?.error_message ||
            marketError.value?.data?.message ||
            marketError.value?.message ||
            "Erreur dans l'édition du marketplace";
          throw new Error(msg);
        }

        await executeWorkdays();
        if (workdaysError.value) {
          const msg =
            workdaysError.value?.data?.error_message ||
            workdaysError.value?.data?.message ||
            workdaysError.value?.message ||
            "Erreur dans l'édition des jours de travail";
          throw new Error(msg);
        }

        return {
          editMarketRes: marketData.value,
          editWorkDaysRes: workdaysData.value,
        };
      } catch (error: any) {
        // Log and re-throw for toast
        console.error(error);
        throw new Error(error.message || "Une erreur s'est produite");
      }
    },
    async fetchMarketPlaces (){
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      let fetchTrace;
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'fetchMarketPlaces');
        fetchTrace.start();
      }

      try {
        const response =  await $fetch <existMarketPlace> ( '/marketplaces/my-market' , {
          method : 'GET',
          headers : {
            Authorization : 'Bearer ' + cookie.value
          },
          baseURL: runTimeConfig.public.baseUrl,
          
        })
        for (const key in response.details) {
          if (Object.prototype.hasOwnProperty.call(response.details, key)) {
             if(response.details[key  as keyof userMarketPlace] === 'null' || response.details[key  as keyof userMarketPlace] === 'undefined'  ){
                  delete response.details[key  as keyof userMarketPlace]
             }
            
          }
        }
        
        this.MarketPlace = response
        // console.log(this.MarketPlace);
        
      } catch (error) {
        // console.log(error);
        throw new Error(String(error))
      } finally {
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }
    },
    async fetchMarketPlacesByName (userName : string,pageNumber?: number){
      const runTimeConfig = useRuntimeConfig();

      try {
        if (!userName || userName === 'undefined') {
          return;
        }

        const safeUserName = encodeURIComponent(userName);
        const response  =  await $fetch <existMarketPlace> (`/marketplaces/by-user-name?m_userName=${safeUserName}&pageNumber=${pageNumber ? pageNumber : 1}` , {
          method : 'GET',
          headers: {
            token: runTimeConfig.public.token,
          },
          baseURL: runTimeConfig.public.baseUrl,

        })
      // console.log(pageNumber);
      // console.log(response);

        if (!pageNumber) {
          this.MarketPlace = response;
        } else {
          if (response && response.announcements && response.announcements.announcements) {
            if (this.MarketPlace && this.MarketPlace.announcements && this.MarketPlace.announcements.announcements) {
              this.MarketPlace.announcements.announcements = [
                ...this.MarketPlace.announcements.announcements,
                ...response.announcements.announcements,
              ];
            } else {
              // If MarketPlace doesn't have announcements, set it
              this.MarketPlace = response;
            }
          }
        }

      } catch (error) {
        // console.log(error);
        throw new Error(String(error))

      }
    }
  },
  persist: createPersistedState({
    key: 'topauto:marketplace',
    version: 1,
    scope: 'user',
    paths: [
      'userChoice',
      'imgDisplay',
      'MarketPlace'
    ]
  })
});
